const hasPercentEncoding = (value) => /%[0-9A-Fa-f]{2}/.test(value);

const countGreekChars = (value) => (value.match(/[\u0370-\u03FF]/g) || []).length;

const countMojibakeChars = (value) => (value.match(/[ÃÂÎÐ]/g) || []).length;

const tryDecodeUriComponent = (value) => {
  if (!hasPercentEncoding(value)) return value;
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

const tryRepairLatin1Utf8 = (value) => {
  try {
    const bytes = Uint8Array.from(value, (char) => char.charCodeAt(0) & 0xff);
    const decoded = new TextDecoder('utf-8', { fatal: true }).decode(bytes);

    const originalGreek = countGreekChars(value);
    const decodedGreek = countGreekChars(decoded);
    const originalMojibake = countMojibakeChars(value);
    const decodedMojibake = countMojibakeChars(decoded);

    const improvedGreek = decodedGreek > originalGreek;
    const reducedMojibake = decodedMojibake < originalMojibake;

    return improvedGreek || reducedMojibake ? decoded : value;
  } catch {
    return value;
  }
};

export const normalizeFileName = (fileName) => {
  if (typeof fileName !== 'string' || fileName.length === 0) return fileName || '';
  const uriDecoded = tryDecodeUriComponent(fileName);
  return tryRepairLatin1Utf8(uriDecoded);
};

